import { Record } from "immutable";
import { STATE_STATUS } from "constants/state-status";

export class CaseEntryRecord extends Record({
    type: null,
    product: null,
    company_name: null,
    gstin: null,
    sales_manager_user_id: null,
    sales_manager_users: [],
    priority: null,
    lead_type: null,
    inside_sales_personnel: null,
    primary_language: null,
    secondary_language: null,
    ledger_masters: [],
    proposed_limit: null,
    previous_case_detail: null,
    previous_case_via_existing_limit: null,
    id: null,
    bank: null,
    sellers: [],
    status: STATE_STATUS.INSTANTIATED,
    business_product_type: null,
    program_type: null,
}) {
    get form() {
        const data = {};
        data.append = function(key, value) {
            this[key] = value;
        };
        data.append("type", this.type);
        data.append("product", this.product && this.product.id);
        data.append("company_name", this.company_name);
        data.append("gstin", this.gstin);
        data.append("priority", 2);
        data.append("sellers", this.sellers && this.sellers.map(_ => _.id));
        data.append("lead_type", 1);
        data.append("sales_manager_user", this.sales_manager_user_id);
        data.append("sales_manager_users", this.sales_manager_users);
        data.append("bank", this.bank && this.bank.id);
        data.append("inside_sales_personnel", this.inside_sales_personnel && this.inside_sales_personnel.id);
        data.append("primary_language", this.primary_language);
        data.append("secondary_language", this.secondary_language);
        if(this.ledger_masters) {
            data.append("ledger_masters", this.ledger_masters.map(_ => _.id));
        }
        if(this.proposed_limit) {
            data.append("proposed_limit", this.proposed_limit);
        }
        return data;
    }
}
